module.exports = __webpack_public_path__ + "static/media/eu_verdadeiro_2.5cc35452.jpg";